<template>
    <div class="all">
        <div class="categoryShow">
            <van-row>
                <van-col span="6">
                    <div>
                        <span>{{indexData.totalInRMB?indexData.totalInRMB:'~'}}</span>
                        <p>累计收入</p>
                    </div>
                </van-col>
                <van-col span="6" v-for="item in indexData.jobFundCountList" :key="item.id">
                    <div>
                        <span>{{item.countRMB}}</span>
                        <p>{{item.name}}</p>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="box u-tri">
            <p>可提现金额: <span>{{indexData.canCashBalanceRMB}}</span></p>
            <van-button round @click="$router.push('/user/cash')">
                申请提现
            </van-button>
        </div>
        <div class="blank"></div>
        <div class="bottom">
            <van-tabs v-model="active" color="darkorange" title-active-color="darkorange" @change="handleTabsChange">
                <van-tab title="收入明细">
                    <div class="showOrder">
                      <div class="table-box" v-if="settleOrderPage.rows&&settleOrderPage.rows.length>0">
                          <table>
                              <tr>
                                  <th>任务名称</th>
                                  <th>收入金额</th>
                                  <th>备注</th>
                                  <th>结算日期起</th>
                                  <th>结算日期止</th>
                                  <!-- <th>结算方式</th> -->
                              </tr>
                              <tr v-for="(row,index) in settleOrderPage.rows" :key="row.id">
                                  <td>{{row.jobName}}</td>
                                  <td>{{row.amountRMB}}</td>
                                  <td>{{row.settleRemark}}</td>
                                  <td>{{row.settleStartDate|parseTime('{y}-{m}-{d}')}}</td>
                                  <td>{{row.settleEndDate|parseTime('{y}-{m}-{d}')}}</td>

                              </tr>
                          </table>
                        </div>
                        <div class="noData" v-else>
                                <div><i class="icon-task icon-ku"></i></div>
                                <div>暂无数据</div>
                        </div>
                        <van-pagination v-model="querySettleOrder.page" :total-items="settleOrderPage.total" :items-per-page="querySettleOrder.limit" @change="handleSettleOrderPageChange" mode="simple" />
                    </div>
                </van-tab>

                <van-tab title="提现记录">
                    <div class="showOrder">
                        <div class="rowOrder" v-if="cashOrderPage.rows&&cashOrderPage.rows.length>0">
                            <van-row class="head">
                                <van-col span="6">申请时间</van-col>
                                <van-col span="6">提现金额</van-col>
                                <van-col span="6">提现状态</van-col>
                                <van-col span="6">审核备注</van-col>
                            </van-row>
                            <van-row v-for="order in cashOrderPage.rows" :key="order.id">
                                <van-col span="6">{{order.gmtCreate|parseTime('{y}-{m}-{d}')}}</van-col>
                                <van-col span="6">{{order.amountRMB}}</van-col>
                                <van-col span="6">{{order.makeMoney?'已打款':statusMap[order.status]}}</van-col>
                                <van-col span="6">{{order.operMsg}}</van-col>
                            </van-row>
                        </div>
                        <div class="noData" v-else>
                                <div><i class="icon-task icon-ku"></i></div>
                                <div>暂无数据</div>
                        </div>
                          <van-pagination v-model="queryCashOrder.page" :total-items="cashOrderPage.total" :items-per-page="queryCashOrder.limit" @change="handleCashOrderPageChange" mode="simple" />
                    </div>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
    import fundAPI from '@/api/fund'
    import zanwushuju from '@/assets/images/zanwushuju.png'

    export default {
        data() {
            return {
                active: 1,
                zanwushuju: zanwushuju,
                indexData:{
                  jobFundCountList:[],
                  canCashBalanceRMB: '',
                  balanceRMB:'',
                  totalInRMB:''
                },
                queryCashOrder:{
                  limit: 8,
                  page: 1
                },
                querySettleOrder:{
                  limit: 8,
                  page: 1
                },
                cashOrderPage: {
                  rows:[],
                  total:0
                },
                settleOrderPage: {
                  rows:[],
                  total:0
                },
                statusMap: {"1": "待审核", "2": "待打款", "3": "失败", "4": "异常"},
                acctStatusMap: {"1": "成功", "2": "异常"},
            }
        },
        created() {
            this.queryIndex()
            this.handleTabsChange()
        },
        methods: {
            queryIndex(){
              fundAPI.index().then((result) => {
                  this.indexData = result.data
              })
            },
            handleTabsChange() {
                if (this.active == 0) {
                    this.querySettleOrderList();
                } else {
                    this.queryCashOrderList();
                }
            },
            //提现记录
            queryCashOrderList() {
              this.$toast.loading({forbidClick:true})
                fundAPI.cashOrderList(this.queryCashOrder).then((result) => {
                    this.cashOrderPage = result.data
                    this.$toast.clear()
                })
            },
            //收支明细
            querySettleOrderList() {
              this.$toast.loading({forbidClick:true})
                fundAPI.settleOrderList(this.querySettleOrder).then((result) => {
                    this.settleOrderPage = result.data
                    this.$toast.clear()
                })
            },
            handleSettleOrderPageChange(){
              this.querySettleOrderList()
            },
            handleCashOrderPageChange(){
              this.queryCashOrderList()
            }
        }
    }
</script>

<style lang="scss" scoped>
    * {
        margin: 0;
    }

    .all {
        background-color: #fff;
    }

    .noData{
      width: 11rem;
      height: 11rem;
      margin: 4rem auto 4rem auto;
      text-align: center;
      color: #E6E6E6;
      i{
        font-size: 5rem;
      }
    }

    .categoryShow {
        position: relative;
        background-color: darkorange;
        padding: 3rem 0px 4rem 0px;
        color: #fff;
        .van-col {
            text-align: center;
            div {
                border-right: 1px dotted rgba(255, 255, 255, 0.5);
                padding: 0rem 0.5rem;
                span {
                    font-size: 1.4rem;
                }
                p {
                    font-size: 1.1rem;
                }
            }

        }

    }

    .box {
        margin-top: -2rem;
        margin-left: 2.5rem;
        margin-right: 2rem;
        position: relative;
        display: inline-block;
        padding: 2rem 20%;
        border-radius: 0.5rem;
        background-color: #fff;
        line-height: 20px;
        font-size: 1.3rem;
        -moz-box-shadow: 0 0 10px #e5e5e5;
        -webkit-box-shadow: 0 0 10px #e5e5e5;
        box-shadow: 0 0 10px #e5e5e5;
        p {
            text-align: center;
        }
    }

    .u-tri:after {
        position: absolute;
        top: -15%;
        left: 10%;
        content: '';
        display: inline-block;
        border-top: 1rem solid transparent;
        border-bottom: 1rem solid #fff;
        border-left: 1rem solid transparent;
        border-right: 1rem solid transparent;
    }

    .van-button {
        margin: 1rem 1rem 0rem 1rem;
        padding: 0rem 2.2rem;
        color: #FFFFFF;
        background: -webkit-linear-gradient(left top, #ffbb5c, coral); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(bottom right, #ffbb5c, coral); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(bottom right, #ffbb5c, coral); /* Firefox 3.6 - 15 */
        background: linear-gradient(to bottom right, #ffbb5c, coral); /* 标准的语法 */
    }

    .blank {
        margin: 1rem;
    }

    .bottom {
        margin: 2rem 1rem;
        font-size: 1.1rem;
        .showOrder {
            text-align: center;
            border-top: 1px solid #f2f2f2;
            border-left: 1px solid #f2f2f2;
            border-right: 1px solid #f2f2f2;
            color: #7d7e80;
            .rowOrder{
              height: 19rem;
              .head{
                color:#000;
              }
            }
            .table-box{
                height: 19rem;
                overflow-x: scroll;
                white-space:nowrap;
                -webkit-overflow-scrolling:touch;
                table tr td{
                  text-align:center;
                  line-height: 1.6rem;
                }
            }
        }

    }


</style>
